const {__, _x, _n, _nx} = wp.i18n;

//Bootstrap component list: Alert, BaseComponent, Button, Carousel, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Tooltip, Toast
import {Collapse} from 'bootstrap';

require('./utilities/class_enlarge.js');
require('./utilities/class_count.js');
require('./utilities/pdw_mobile_menu.js');
require('./utilities/pdw_drilldown_menu.js');
require('./utilities/pdw_modal_search.js');
require('./utilities/pdw_carousel.js');
require('./utilities/pdw_slider.js');
require('./utilities/pdw_hide_link.js');
require('./utilities/pdw_scrolled.js');
require('./utilities/pdw_lightbox.js');
//require('./utilities/pdw_woocommerce.js');

import { Splide } from '@splidejs/splide';
import { Video } from '@splidejs/splide-extension-video';

document.addEventListener("DOMContentLoaded", () => {
    const sliders = document.querySelectorAll('.splide-video');

    sliders.forEach(item => {
        const slideCount = item.querySelectorAll('.splide__slide').length;
        const hasOnlyOneSlide = slideCount === 1;

        const splide = new Splide(item, {
            type: hasOnlyOneSlide ? 'loop' : 'slide',
            autoplay: false,
            video: {
                mute: true,
                autoplay: true,
                playerOptions: {
                    youtube: {},
                    vimeo: {},
                    htmlVideo: {
                        autoplay: true,
                        loop: hasOnlyOneSlide, // boucle si une seule slide
                        playsInline: true,
                        muted: true
                    },
                }
            },
        });

        splide.mount({ Video });

        if (!hasOnlyOneSlide) {
            // Si plusieurs slides, passe à la suivante quand la vidéo se termine
            splide.on('video:ended', () => {
                splide.go('>');
            });
        }
    });
});